import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable, ErrorHandler } from '@angular/core';
import { KeyValue } from '@angular/common';
import {
  IApiResponse,
  IFilterPaginationDto,
  IMenuImageTagDto,
  IThirdPartyDeliveryDto,
} from '../models';

@Injectable()
export class MasterService extends ApiService {
  constructor(http: HttpClient, errorHandler: ErrorHandler) {
    super(http, errorHandler);
  }

  public getThirdPartyDeliveryMasterList(
    model: IFilterPaginationDto
  ): Observable<IThirdPartyDeliveryDto[]> {
    return this.post(`admin/master/thirdParty/list`, model);
  }

  public getThirdPartyDeliveryMaster(): Observable<KeyValue<number, string>[]> {
    return this.get(`admin/master/thirdParty`);
  }

  public addThirdPartyDeliveryMaster(
    model: IThirdPartyDeliveryDto
  ): Observable<IApiResponse<boolean>> {
    return this.post(`admin/master/thirdParty/save`, model);
  }

  public changeThirdPartyDeliveryMasterStatus(
    id: number
  ): Observable<IApiResponse<boolean>> {
    return this.put(`admin/master/thirdParty/${id}`, null);
  }

  public deleteThirdPartyDeliveryMaster(
    id: number
  ): Observable<IApiResponse<boolean>> {
    return this.delete(`admin/master/thirdParty/${id}`);
  }

  public getMenuImageTagMasterMasterList(
    model: IFilterPaginationDto
  ): Observable<IMenuImageTagDto[]> {
    return this.post(`admin/master/menuImageTag/list`, model);
  }

  public addMenuImageTagMasterMaster(
    model: IMenuImageTagDto
  ): Observable<IApiResponse<boolean>> {
    return this.post(`admin/master/menuImageTag/save`, model);
  }

  public changeMenuImageTagMasterStatus(
    id: number
  ): Observable<IApiResponse<boolean>> {
    return this.put(`admin/master/menuImageTag/${id}`, null);
  }

  public deleteMenuImageTagMaster(
    id: number
  ): Observable<IApiResponse<boolean>> {
    return this.delete(`admin/master/menuImageTag/${id}`);
  }
}
